var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentNameFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 114,
    viewBox: "0 0 285 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_239)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_401_239",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 285,
    height: 114
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285 0H0V114H285V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_401_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.465 12.7795C270.937 7.24437 263.58 4.19189 255.777 4.19189H29.2641C15.2824 4.19189 3.21092 14.1226 0.569025 27.8384L0.406446 28.571V28.6524C0.121934 30.2804 0 31.9084 0 33.5364V84.7367C0 92.551 3.04835 99.9177 8.57601 105.453C14.1037 110.988 21.4604 114.041 29.2641 114.041H255.777C263.58 114.041 270.937 110.988 276.465 105.453C281.992 99.9177 285.041 92.551 285.041 84.7367V33.4957C285 25.6814 281.992 18.3147 276.465 12.7795ZM277.643 84.696C277.643 96.8245 267.848 106.633 255.736 106.633H29.2641C17.1927 106.633 7.35667 96.8245 7.35667 84.696V33.4957C7.35667 32.0712 7.47861 30.6467 7.76312 29.3036C9.75471 19.2101 18.6152 11.5992 29.2641 11.5992H255.777C267.848 11.5992 277.684 21.4079 277.684 33.5364V84.696H277.643Z",
    fill: "#BF8F52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.465 8.58765C270.937 3.05248 263.58 0 255.777 0H29.2641C15.2824 0 3.21092 9.93074 0.52838 23.6466L0.406446 24.3384V24.4198C0.121934 26.0478 0 27.6758 0 29.3038V80.5041C0 88.3185 3.04835 95.6851 8.57601 101.22C14.1037 106.755 21.4604 109.808 29.2641 109.808H255.777C263.58 109.808 270.937 106.755 276.465 101.22C281.992 95.6851 285.041 88.3185 285.041 80.5041V29.3038C285 21.4895 281.992 14.1228 276.465 8.58765ZM277.643 80.5041C277.643 92.6326 267.848 102.441 255.736 102.441H29.2641C17.1927 102.441 7.35667 92.6326 7.35667 80.5041V29.3038C7.35667 27.8793 7.47861 26.4548 7.76312 25.1117C9.75471 14.9775 18.6152 7.36665 29.2641 7.36665H255.777C267.848 7.36665 277.684 17.1753 277.684 29.3038V80.5041H277.643Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M276.465 8.58765C270.937 3.05248 263.58 0 255.777 0H29.2641C15.2824 0 3.21092 9.93074 0.52838 23.6466L0.406446 24.3384V24.4198C0.121934 26.0478 0 27.6758 0 29.3038V32.8854C0 31.2574 0.121934 29.6294 0.406446 28.0014V27.92L0.52838 27.2281C3.21092 13.5123 15.2824 3.58158 29.2641 3.58158H255.777C263.58 3.58158 270.937 6.63406 276.465 12.1692C281.992 17.7044 285.041 25.071 285.041 32.8854V29.3038C285 21.4895 281.992 14.1228 276.465 8.58765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.643 29.3039V80.5041C277.643 92.6327 267.848 102.441 255.736 102.441H29.2641C17.1927 102.441 7.35669 92.6327 7.35669 80.5041V29.3039C7.35669 27.8794 7.47862 26.4549 7.76314 25.1118C9.75472 14.9776 18.6152 7.3667 29.2641 7.3667H255.777C267.848 7.3667 277.643 17.1753 277.643 29.3039Z",
    fill: "#5E639B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M231.512 12.8203H25.85C25.85 12.8203 45.1155 47.9849 100.026 38.5833C154.856 29.1409 182.047 15.2623 231.512 12.8203Z",
    fill: "url(#paint0_linear_401_239)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M51.1309 98.7785H256.793C256.793 98.7785 237.527 63.6139 182.616 73.0155C127.746 82.4579 100.555 96.3365 51.1309 98.7785Z",
    fill: "url(#paint1_linear_401_239)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.599 93.8945C249.07 96.6214 261.467 95.8481 264.068 94.0573C266.629 92.3072 269.962 84.3707 267.035 83.1497C265.694 82.5799 250.127 91.1269 249.599 93.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0602 11.7622C34.5073 9.48307 24.2242 10.5412 21.8262 11.5994C13.8598 15.1403 16.8269 19.7801 19.3062 20.8383C20.4442 21.3267 33.6131 14.1228 34.0602 11.7622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3959 24.6235C15.9733 22.4664 12.9656 21.5303 11.9495 22.4257C10.6489 23.5653 9.71405 31.2169 11.4618 31.0134C12.2747 30.932 18.2494 25.9666 17.3959 24.6235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.519 103.784L188.185 107.406L192.859 109.808H187.168L184.689 106.796L181.519 103.784Z",
    fill: "#BF8F52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.519 103.784L184.161 107.732L183.876 109.767H187.168C187.168 109.808 183.632 105.412 181.519 103.784Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.978 3.05225L206.068 5.90123L206.271 7.36642H203.914C203.914 7.36642 206.475 4.23254 207.978 3.05225Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4833 109.808L93.7671 107.325L96.7748 103.377L96.0026 108.18L93.32 109.808H88.4833Z",
    fill: "#BF8F52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7748 103.377L92.6291 106.633L84.175 109.808H88.4833L93.7671 107.325L96.7748 103.377Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53.8457L2.43868 59.1367L6.42185 62.1484L1.58514 61.3345L0 58.689V53.8457Z",
    fill: "#BF8F52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42185 62.1487L3.17028 57.9973L0 49.5317V53.8459L2.43868 59.1369L6.42185 62.1487Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.74 7.36665H173.837C174.569 4.96537 175.097 2.48268 175.422 0H174.325C174 2.48268 173.471 4.92467 172.74 7.36665Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.532 0C202.37 2.48268 202.329 4.92467 202.41 7.36665H203.467C203.386 4.92467 203.426 2.44199 203.589 0H202.532Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43 7.36665C120.024 4.88397 119.455 2.40129 118.723 0H117.625C118.357 2.40129 118.926 4.88397 119.373 7.36665H120.43Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.136 102.4C243.055 103.296 243.014 104.232 243.095 105.127C243.217 106.715 243.502 108.261 243.908 109.767H245.006C244.559 108.22 244.233 106.633 244.152 105.046C244.071 104.191 244.112 103.296 244.233 102.4H243.136Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68 7.36665H250.737C251.062 4.92467 251.306 2.44199 251.387 0H250.371C250.249 2.48268 250.005 4.92467 249.68 7.36665Z",
    fill: "#BF8F52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2493 7.36665H77.3873C76.2493 4.80257 74.908 2.36059 73.4042 0H72.1442C73.7293 2.36059 75.0706 4.80257 76.2493 7.36665Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M7.35667 89.2139C6.29991 84.2079 6.54378 79.1204 7.35667 74.0329V68.335C5.89346 75.3353 4.8367 82.4171 6.34056 89.4174C7.64118 95.441 11.0147 101.139 15.892 105.453C16.9082 106.349 17.9649 107.163 19.0623 107.936C20.3223 108.424 21.6636 108.791 22.9642 109.075C15.2417 105.168 9.22632 97.8423 7.35667 89.2139Z",
    fill: "#D7A05C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.643 44.9326V46.0722C280.407 47.5781 282.886 49.6131 285 51.933V50.4678C282.765 48.1886 280.285 46.3164 277.643 44.9326Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7531 109.645C76.8589 107.447 76.0054 105.005 75.3144 102.441H74.217C74.908 105.087 75.7615 107.57 76.6557 109.808H77.7938C77.8344 109.727 77.7938 109.686 77.7531 109.645Z",
    fill: "#D7A05C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.374 109.808C230.699 107.325 230.78 104.883 230.658 102.441H229.601C229.723 104.883 229.683 107.366 229.317 109.808H230.374Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.174 101.464C263.052 101.383 262.889 101.342 262.767 101.261C262.32 101.424 261.833 101.546 261.385 101.668C261.833 101.912 262.28 102.156 262.727 102.4C265.694 103.906 269.027 104.639 272.278 104.68C272.766 104.354 273.294 103.988 273.782 103.581C270.165 103.825 266.466 103.133 263.174 101.464Z",
    fill: "#BF8F52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.503 102.4H179.324C180.462 104.842 181.641 107.325 182.941 109.767H184.12C182.819 107.366 181.641 104.883 180.503 102.4Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5739 8.13986C22.761 5.81998 22.0294 3.45939 21.5416 1.05811C21.2165 1.1395 20.8507 1.2616 20.5255 1.343C21.0132 3.74429 21.7449 6.10487 22.5577 8.42476C22.8829 8.30266 23.2081 8.22126 23.5739 8.13986Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35667 29.9957V29.3038C7.35667 28.8561 7.35667 28.4084 7.39732 27.9607C5.73089 25.2339 3.69866 22.7105 1.34127 20.5127C1.21934 20.879 1.0974 21.2453 1.01611 21.6523C3.53608 24.0536 5.69024 26.9026 7.35667 29.9957Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.356 102.726C128.356 102.604 128.396 102.522 128.396 102.4H127.34C127.34 102.482 127.34 102.563 127.299 102.604C127.096 105.005 126.811 107.406 126.486 109.767H127.543C127.909 107.447 128.152 105.087 128.356 102.726Z",
    fill: "#FFBE6D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M47.1477 108.912C48.9768 107.04 50.0742 104.842 50.6432 102.4H49.5458C49.0174 104.557 48.0013 106.511 46.4161 108.18C45.8065 108.79 45.1562 109.319 44.4246 109.767H46.2129C46.5381 109.523 46.8632 109.238 47.1477 108.912Z",
    fill: "#D7A05C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_239",
    x1: 110.624,
    y1: -45.9252,
    x2: 136.662,
    y2: 38.5821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9500F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_401_239",
    x1: 159.378,
    y1: 128.803,
    x2: 149.974,
    y2: 76.7907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9500F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 285,
    height: 114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentNameFrame);
export default __webpack_public_path__ + "static/media/StudentNameFrame.6212c6a56908c7247b1377c1c65f290c.svg";
export { ForwardRef as ReactComponent };